import { render, staticRenderFns } from "./_option.vue?vue&type=template&id=3a19614f&scoped=true&"
import script from "./_option.vue?vue&type=script&lang=js&"
export * from "./_option.vue?vue&type=script&lang=js&"
import style0 from "./_option.vue?vue&type=style&index=0&id=3a19614f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19614f",
  null
  
)

export default component.exports